import React from 'react';
import { FlexBox, Typography, Grid } from '@kis-technologies/kis-ui';
import { UniqueOffers } from '../../TicketRow/types';

interface TicketCardProps {
  bg: string;
  disabled: boolean;
  formattedPrice: string;
  offer: UniqueOffers;
  textColor: string;
  addToCart: (offer: UniqueOffers) => void;
}

export const TicketCard = (props: TicketCardProps) => {
  const { bg, formattedPrice, offer, addToCart, textColor, disabled } = props;
  const { type } = offer;

  const handleClick = () => {
    if (!disabled) {
      addToCart(offer);
    }
  };

  return (
    <Grid item>
      <FlexBox
        direction="column"
        height="168px"
        width="404px"
        raised
        hasBorderRadius
        onClick={() => handleClick()}
        margin="2 3"
        sx={{ backgroundColor: bg }}
      >
        <FlexBox padding="4 0 0" justify="center" align="center" fullWidth>
          <Typography fontSize={50} color={textColor}>
            {' '}
            {formattedPrice}
          </Typography>
        </FlexBox>
        <FlexBox fullWidth justify="center" align="center">
          <Typography sx={{ lineHeight: 1.91 }} fontSize={24} fontWeight={400} color={textColor}>
            {type}
          </Typography>
        </FlexBox>
      </FlexBox>
    </Grid>
  );
};
